import * as React from 'react'

export const HeadingFiveIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M19.304 13.1748C20.4426 13.1748 21.3477 13.4944 22.019 14.1335C22.6958 14.7727 23.0342 15.6482 23.0342 16.76C23.0342 18.0759 22.6287 19.0884 21.8176 19.7974C21.0066 20.5063 19.8464 20.8608 18.3372 20.8608C17.0266 20.8608 15.9685 20.6487 15.1628 20.2244V18.0732C15.5872 18.2988 16.0813 18.4841 16.6453 18.6292C17.2092 18.7688 17.7437 18.8386 18.2485 18.8386C19.7686 18.8386 20.5286 18.2156 20.5286 16.9695C20.5286 15.7825 19.7417 15.189 18.168 15.189C17.8833 15.189 17.5691 15.2185 17.2253 15.2776C16.8816 15.3313 16.6023 15.3904 16.3875 15.4548L15.3965 14.9231L15.8396 8.9209H22.2285V11.0317H18.0229L17.8054 13.344L18.0874 13.2876C18.415 13.2124 18.8206 13.1748 19.304 13.1748Z'
        fill='currentColor'
      />
      <path
        d='M3.85718 2.69971V9.44971H9.85718V2.69971H12.8572V20.6997H9.85718V12.8247H3.85718V20.6997H0.857178V2.69971H3.85718Z'
        fill='currentColor'
      />
    </svg>
  )
})

HeadingFiveIcon.displayName = 'HeadingFiveIcon'
